import clsx from "clsx";

import { formatChatTimestamp } from "../../utils";

interface TimestampDisplayProps {
  createdAt: number;
  unreadCount: number;
}

export default function TimestampDisplay({
  createdAt,
  unreadCount,
}: TimestampDisplayProps) {
  return (
    <span
      className={clsx([
        unreadCount
          ? "text-xxs-bold text-black-950"
          : "text-xxs text-black-600",
      ])}
    >
      {formatChatTimestamp(createdAt)}
    </span>
  );
}
